// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_PAGE = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
};

/** Association portal paths only — Minimals/admin template leftovers removed (AF-06). */
export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    overview: path(ROOTS_DASHBOARD, '/overview'),
  },
  member: {
    root: path(ROOTS_DASHBOARD, '/member'),
    list: path(ROOTS_DASHBOARD, '/member/list'),
    new: path(ROOTS_DASHBOARD, '/member/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/member/edit/${id}/`),
    detail: (id) => path(ROOTS_DASHBOARD, `/member/detail/${id}/`),
  },
  post: {
    root: path(ROOTS_DASHBOARD, '/post'),
    list: path(ROOTS_DASHBOARD, '/post/list'),
    new: path(ROOTS_DASHBOARD, '/post/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/post/edit/${id}/`),
    view: (id) => path(ROOTS_DASHBOARD, `/post/${id}/`),
  },
  designationinassociation: {
    root: path(ROOTS_DASHBOARD, '/designationinassociation'),
    list: path(ROOTS_DASHBOARD, '/designationinassociation/list'),
    new: path(ROOTS_DASHBOARD, '/designationinassociation/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/designationinassociation/edit/${id}/`),
    detail: (id) => path(ROOTS_DASHBOARD, `/designationinassociation/${id}/`),
  },
  city: {
    root: path(ROOTS_DASHBOARD, '/city'),
    list: path(ROOTS_DASHBOARD, '/city/list'),
    new: path(ROOTS_DASHBOARD, '/city/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/city/edit/${id}/`),
    view: (id) => path(ROOTS_DASHBOARD, `/city/${id}/`),
  },
  uploadDocument: {
    root: path(ROOTS_DASHBOARD, '/upload-document/update'),
  },
};
